import Group from 'components/utils/Group'
import ModalBody from 'LuxKit/Modal/ModalBody'
import React, { useCallback, useContext } from 'react'
import ModalContent from 'LuxKit/Modal/ModalContent'
import TextButton from 'LuxKit/Button/TextButton'
import Caption from 'LuxKit/Typography/Caption'
import ListItem from 'LuxKit/List/ListItem'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import LineBuildingIcon from 'LuxKit/Icons/line/LineBuildingIcon'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import { BusinessTravellerPersonalAccountLinkingStateContext } from 'businessTraveller/contexts/BusinessTravellerPersonalAccountLinkingContexts'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

function BusinessTravellerPersonalAccountLinkConfirmationSetupStep() {
  const {
    businessDetails,
    employeeProfile,
    personalEmail,
  } = useContext(BusinessTravellerPersonalAccountLinkingStateContext)
  const modalElement = useModalElementContext<boolean>()

  const endSetup = useCallback(() => {
    modalElement.resolve(true)
  }, [modalElement])

  return <>
    <ModalHeader
      title={`Congratulations ${employeeProfile?.firstName}, your personal email has been successfully updated.`}
    />
    <ModalBody>
      <ModalContent>
        <Group direction="vertical" gap={24}>
          <Group direction="vertical" gap={8}>
            <Caption variant="small" format="uppercase">
              Your profiles:
            </Caption>
            <div>
              {employeeProfile?.email && businessDetails?.name && <ListItem
                startIcon={<LineBuildingIcon />}
                title={`Business · ${businessDetails?.name}`}
                subtitle={employeeProfile?.email}
              />}
              {personalEmail && <ListItem
                startIcon={<LineUserIcon />}
                title="Personal"
                subtitle={personalEmail}
              />}
            </div>
          </Group>

          <Group direction="horizontal" horizontalAlign="end">
            <TextButton type="button" kind="primary" size="large" onClick={endSetup}>
              Close
            </TextButton>
          </Group>
        </Group>
      </ModalContent>
    </ModalBody>
  </>
}

export default BusinessTravellerPersonalAccountLinkConfirmationSetupStep
